import React from 'react';
import SubLayout from '../../components/layouts/SubLayout';

const ShoppingList = React.memo(() => {
  return (
    <SubLayout />
  );
});

export default ShoppingList;